import store from "@/store";
import config from "@/config";
import { logout } from "@/store/slices/auth/authSlice";
import storage from "./storage";

export const globalLogout = (shouldRedirect = false) => {
  console.log("on logout");
  const hostDomain = JSON.parse(storage.getItem("Profile"))?.HostDomain;
  let originUrl = globalThis?.window?.location?.origin || "";
  let currentUrl = "";

  if (config.environment === "development") {
    currentUrl = config.customerPortalURL.replace("my.", "");
  } else {
    currentUrl = originUrl.replace("crm.", "") + "/";
  }
  const url = hostDomain || currentUrl;
  store.dispatch(logout());

  if (shouldRedirect && url) {
    let legacyURL =
      url + `/Pages/Logout.aspx?isNewPortalRedirect=true&isCRMRedirect=true`;
    setTimeout(() => {
      window.location.href = legacyURL;
    }, 1000);
  }
};
